/* Planet Sport Italia — theme.js */
(function() {
  'use strict';
  var qtyTimers = {};
  var desiredQty = {};   /* ultima quantita' voluta per riga: e' quella che viene inviata */
  var cartSeq = 0;       /* solo la risposta piu' recente aggiorna la UI */
  var cartChain = Promise.resolve(); /* coda seriale: mai due scritture carrello in volo insieme */
  var pendingWrites = 0;
  function setSyncing(on) {
    pendingWrites = Math.max(0, pendingWrites + (on ? 1 : -1));
    var busy = pendingWrites > 0;
    var bar = document.querySelector('#cart-drawer .psi-fs-bar');
    if (bar) bar.classList.toggle('psi-fs-syncing', busy);
    var sub = document.getElementById('cart-subtotal');
    if (sub) sub.classList.toggle('psi-sync', busy);
  }
  function cartEnqueue(task) {
    setSyncing(true);
    cartChain = cartChain.then(task, task).then(function(v) { setSyncing(false); return v; }, function(e) { setSyncing(false); throw e; });
    return cartChain;
  }
  var CartAPI = {
    add: function(variantId, quantity, callback) {
      var seq = ++cartSeq;
      cartEnqueue(function() {
        return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify({ id: variantId, quantity: quantity || 1 }) })
        .then(function(r) { return r.json(); })
        .then(function(data) { if (seq === cartSeq) CartAPI.updateDrawer(); if (callback) callback(data); })
        .catch(function(e) { console.error('Cart add error:', e); });
      });
    },
    change: function(key, quantity, rerender) {
      var seq = ++cartSeq;
      return cartEnqueue(function() {
        /* invia sempre l'ultimo valore voluto per questa riga, non quello di quando e' stato programmato */
        var q = (typeof desiredQty[key] === 'number') ? desiredQty[key] : quantity;
        return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify({ id: key, quantity: q }) })
        .then(function(r) { return r.json(); }).then(function(cart) {
          if (seq !== cartSeq) return; /* superata da un'operazione piu' recente */
          if (rerender === false && cart && typeof cart.total_price !== 'undefined') { applyTotals(cart.total_price, cart.item_count); }
          else { CartAPI.updateDrawer(); }
        }).catch(function(e) { console.error('Cart change error:', e); if (seq === cartSeq) CartAPI.updateDrawer(); });
      });
    },
    clear: function() {
      var seq = ++cartSeq;
      desiredQty = {};
      return cartEnqueue(function() {
        return fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function(r) { if (!r.ok) throw new Error('Cart clear failed'); return r.json(); })
        .then(function(cart) { if (seq === cartSeq) CartAPI.updateDrawer(); return cart; });
      });
    },
    updateDrawer: function() {
      var seq = ++cartSeq;
      desiredQty = {}; /* il markup ricaricato ridiventa la verita' */
      fetch('/?section_id=cart-drawer').then(function(r) { return r.text(); }).then(function(html) {
        if (seq !== cartSeq) return;
        var parser = new DOMParser(); var doc = parser.parseFromString(html, 'text/html');
        var newBody = doc.querySelector('#cart-drawer-body'); var newFooter = doc.querySelector('#cart-drawer-footer'); var newCount = doc.querySelector('#cart-count-drawer');
        if (newBody && document.getElementById('cart-drawer-body')) document.getElementById('cart-drawer-body').innerHTML = newBody.innerHTML;
        if (newFooter && document.getElementById('cart-drawer-footer')) document.getElementById('cart-drawer-footer').innerHTML = newFooter.innerHTML;
        if (newCount) {
          var count = newCount.textContent.trim();
          document.querySelectorAll('#cart-count, #cart-count-drawer').forEach(function(el) { el.textContent = count; el.classList.toggle('hidden', count === '0'); });
          var clearButton = document.getElementById('cart-clear');
          if (clearButton) { clearButton.hidden = count === '0'; clearButton.disabled = false; clearButton.removeAttribute('aria-busy'); }
        }
        CartAPI.bindDrawerEvents();
      });
    }
  };
  function bindAddToCart() { document.addEventListener('click', function(e) { var target = e.target; var btn = target && target.closest ? target.closest('.btn-add-to-cart[data-variant-id]') : null; if (!btn) return; e.preventDefault(); if (btn.disabled || btn.classList.contains('loading')) return; var variantId = btn.dataset.variantId; var title = btn.dataset.productTitle || 'Prodotto'; btn.classList.add('loading'); btn.textContent = '...'; CartAPI.add(variantId, 1, function() { btn.classList.remove('loading'); btn.innerHTML = '✓ Aggiunto'; btn.classList.add('added'); CartDrawer.open(); showNotification('✓ ' + title + ' aggiunto al carrello!'); setTimeout(function() { btn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg> Aggiungi'; btn.classList.remove('added'); }, 2000); }); }); }
  var CartDrawer = { el: document.getElementById('cart-drawer'), overlay: document.getElementById('cart-overlay'), open: function() { this.el && this.el.setAttribute('aria-hidden', 'false'); this.el && this.el.classList.add('open'); this.overlay && this.overlay.classList.add('visible'); document.body.classList.add('cart-open'); }, close: function() { this.el && this.el.setAttribute('aria-hidden', 'true'); this.el && this.el.classList.remove('open'); this.overlay && this.overlay.classList.remove('visible'); document.body.classList.remove('cart-open'); } };
  var addToCartMain = document.getElementById('add-to-cart-btn');
  if (addToCartMain) addToCartMain.addEventListener('click', function() { if (addToCartMain.disabled) return; var variantId = document.getElementById('selected-variant-id').value; var qty = parseInt(document.getElementById('qty-input').value) || 1; addToCartMain.classList.add('loading'); var originalText = addToCartMain.innerHTML; addToCartMain.innerHTML = '<span class="spinner"></span> Aggiunta in corso...'; CartAPI.add(variantId, qty, function() { addToCartMain.innerHTML = '✓ Aggiunto al carrello!'; addToCartMain.classList.remove('loading'); addToCartMain.classList.add('added'); CartDrawer.open(); showNotification('✓ Prodotto aggiunto al carrello!'); setTimeout(function() { addToCartMain.innerHTML = originalText; addToCartMain.classList.remove('added'); }, 2500); }); });
  var cartToggle = document.getElementById('cart-toggle'); var cartClose = document.getElementById('cart-close'); var cartOverlay = document.getElementById('cart-overlay');
  if (cartToggle) cartToggle.addEventListener('click', function() { CartDrawer.open(); }); if (cartClose) cartClose.addEventListener('click', function() { CartDrawer.close(); }); if (cartOverlay) cartOverlay.addEventListener('click', function() { CartDrawer.close(); });
  var cartContinue = document.getElementById('cart-continue'); if (cartContinue) cartContinue.addEventListener('click', function(e) { e.preventDefault(); CartDrawer.close(); });
  var cartClear = document.getElementById('cart-clear');
  if (cartClear) cartClear.addEventListener('click', function() {
    if (cartClear.disabled) return;
    cartClear.disabled = true;
    cartClear.setAttribute('aria-busy', 'true');
    document.querySelectorAll('#cart-drawer .cart-item').forEach(function(li) {
      li.style.height = li.getBoundingClientRect().height + 'px';
      li.offsetHeight;
      li.classList.add('is-removing');
      requestAnimationFrame(function() { li.style.height = '0px'; });
    });
    recalcOptimistic();
    CartAPI.clear().catch(function(e) {
      console.error('Cart clear error:', e);
      CartAPI.updateDrawer();
    });
  });
  CartAPI.bindDrawerEvents = function() {
    document.querySelectorAll('#cart-drawer .qty-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var key = btn.dataset.key;
        var action = btn.dataset.action;

        if (action === 'remove') {
          var li = btn.closest('.cart-item');
          if (li && !li.classList.contains('is-removing')) {
            btn.disabled = true;
            li.style.height = li.getBoundingClientRect().height + 'px';
            li.offsetHeight;
            li.classList.add('is-removing');
            requestAnimationFrame(function() { li.style.height = '0px'; });
            recalcOptimistic();
          }
          desiredQty[key] = 0;
          clearTimeout(qtyTimers[key]);
          CartAPI.change(key, 0);
          return;
        }

        var qtyEl = btn.parentElement.querySelector('.qty-num');
        var readQ = function(){ return parseInt(qtyEl.tagName === 'INPUT' ? qtyEl.value : qtyEl.textContent) || 1; };
        var setQ = function(v){ if (qtyEl.tagName === 'INPUT') qtyEl.value = v; else qtyEl.textContent = v; };
        var oldQty = readQ();
        var qty = oldQty;
        if (action === 'increase') qty++;
        else qty = Math.max(1, qty - 1); /* minimo 1: non scende sotto */

        /* Se il valore non cambia (già a 1 e si preme -), non fare nulla */
        if (qty === oldQty) return;

        /* Aggiornamento ottimistico: numero con bump */
        setQ(qty);
        qtyEl.style.transition = 'transform .15s';
        qtyEl.style.transform = 'scale(1.3)';
        setTimeout(function() { qtyEl.style.transform = 'scale(1)'; }, 150);

        /* Prezzo: aggiorna solo i digit, lascia il simbolo € dov'è */
        var info = btn.closest('.cart-item-info');
        var priceEl = info && info.querySelector('.cart-item-price');
        if (priceEl) {
          var unitPrice = parseInt(priceEl.dataset.unitPrice, 10) || 0;
          if (unitPrice > 0) {
            var cents = unitPrice * qty;
            var eur = Math.floor(cents / 100);
            var cen = cents % 100;
            var numStr = eur + ',' + (cen < 10 ? '0' + cen : cen);
            /* Sostituisce solo la parte numerica nel testo, senza toccare il simbolo */
            var cur = priceEl.textContent;
            var replaced = cur.replace(/[\d.,]+(?=\s*[€\u20ac])|(?<=[€\u20ac]\s*)[\d.,]+/, numStr);
            priceEl.textContent = (replaced !== cur) ? replaced : numStr + '\u202f\u20ac';
          }
        }

        recalcOptimistic();
        /* Sincronizza subito: il totale/barra spedizione arriva sempre dal server
           (una stima lato browser sbaglierebbe con sconti o prezzi a scaglioni). */
        if (priceEl) priceEl.dataset.qty = qty;
        desiredQty[key] = qty;
        clearTimeout(qtyTimers[key]);
        CartAPI.change(key, qty, false);
      });
    });

    /* Quantità digitabile: apre la tastiera numerica e aggiorna il carrello */
    document.querySelectorAll('#cart-drawer input.qty-num').forEach(function(inp) {
      var commit = function() {
        var key = inp.dataset.key;
        var q = Math.max(1, parseInt(String(inp.value).replace(/[^0-9]/g, '')) || 1);
        inp.value = q;
        /* Aggiorna subito anche il prezzo della riga, non solo con i pulsanti +/- */
        var li = inp.closest('.cart-item');
        var priceEl = li && li.querySelector('.cart-item-price');
        if (priceEl) {
          var up = parseInt(priceEl.dataset.unitPrice, 10) || 0;
          if (up > 0) {
            var cents = up * q;
            var eur = Math.floor(cents / 100);
            var cen = cents % 100;
            var numStr = eur + ',' + (cen < 10 ? '0' + cen : cen);
            var cur = priceEl.textContent;
            var replaced = cur.replace(/[\d.,]+(?=\s*[€\u20ac])|(?<=[€\u20ac]\s*)[\d.,]+/, numStr);
            priceEl.textContent = (replaced !== cur) ? replaced : numStr + '\u202f\u20ac';
            priceEl.dataset.qty = q;
          }
        }
        recalcOptimistic();
        if (key) { desiredQty[key] = q; clearTimeout(qtyTimers[key]); CartAPI.change(key, q, false); }
      };
      inp.addEventListener('focus', function() { setTimeout(function(){ inp.select(); }, 0); });
      inp.addEventListener('change', commit);
      inp.addEventListener('blur', function(e) {
        /* se il focus va al +/- accanto ci pensa lui: evita un doppio invio con la quantita' vecchia */
        if (e.relatedTarget && e.relatedTarget.classList && e.relatedTarget.classList.contains('qty-btn')) return;
        commit();
      });
      inp.addEventListener('keydown', function(e) { if (e.key === 'Enter') { e.preventDefault(); inp.blur(); } });
    });
  };
  CartAPI.bindDrawerEvents();
  function psiMoney(cents) {
    cents = Math.round(cents || 0);
    var neg = cents < 0 ? '-' : ''; cents = Math.abs(cents);
    var e = Math.floor(cents / 100), c = cents % 100;
    var eStr = String(e).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return neg + '\u20ac' + eStr + ',' + (c < 10 ? '0' + c : c);
  }
  function applyTotals(totalCents, itemCount) {
    var sub = document.getElementById('cart-subtotal');
    if (sub) sub.textContent = psiMoney(totalCents);
    document.querySelectorAll('#cart-count, #cart-count-drawer').forEach(function(el) {
      el.textContent = itemCount;
      el.classList.toggle('hidden', String(itemCount) === '0');
    });
    var clearButton = document.getElementById('cart-clear');
    if (clearButton) clearButton.hidden = Number(itemCount) === 0;
    var bar = document.querySelector('#cart-drawer .psi-fs-bar');
    if (bar) {
      var thr = parseInt(bar.dataset.threshold) || 0;
      if (thr > 0) {
        var pct = Math.min(100, Math.round(totalCents * 100 / thr));
        var fill = bar.querySelector('.psi-fs-fill'); if (fill) fill.style.width = pct + '%';
        var txt = bar.querySelector('.psi-fs-text');
        if (totalCents >= thr) { bar.classList.add('psi-fs-done'); if (txt) txt.innerHTML = '\u2713 Hai ottenuto la <b>spedizione gratuita</b>'; }
        else { bar.classList.remove('psi-fs-done'); if (txt) txt.innerHTML = 'Ti mancano <b>' + psiMoney(thr - totalCents) + '</b> per la <b>spedizione gratuita</b>'; }
      }
    }
  }
  function recalcOptimistic() {
    /* Solo il conteggio articoli e' sempre esatto lato client: aggiornalo subito.
       Il totale e la barra spedizione arrivano dal server (una stima sbaglierebbe
       con sconti automatici o prezzi a scaglioni e poi "tornerebbe indietro"). */
    var count = 0;
    document.querySelectorAll('#cart-drawer .cart-item:not(.is-removing) .qty-num').forEach(function(qEl) {
      count += parseInt(qEl.tagName === 'INPUT' ? qEl.value : qEl.textContent) || 0;
    });
    document.querySelectorAll('#cart-count, #cart-count-drawer').forEach(function(el) {
      el.textContent = count;
      el.classList.toggle('hidden', count === 0);
    });
    var clearButton = document.getElementById('cart-clear');
    if (clearButton) clearButton.hidden = count === 0;
  }
  function showNotification(msg) { var el = document.getElementById('cart-notification'); if (!el) return; el.textContent = msg; el.classList.add('show'); clearTimeout(el._timer); el._timer = setTimeout(function() { el.classList.remove('show'); }, 3000); }
  var header = document.getElementById('site-header'); if (header) window.addEventListener('scroll', function() { header.classList.toggle('scrolled', window.scrollY > 60); }, { passive: true });
  var heroSlides = document.querySelectorAll('.hero-slide'); var heroDots = document.querySelectorAll('.hero-dot'); var heroCurrentEl = document.getElementById('hero-current'); var heroIdx = 0, heroTimer; var heroSpeed = 5000;
  function heroGoTo(n) { if (!heroSlides.length) return; heroSlides[heroIdx].classList.remove('active'); heroDots[heroIdx] && heroDots[heroIdx].classList.remove('active'); heroIdx = (n + heroSlides.length) % heroSlides.length; heroSlides[heroIdx].classList.add('active'); heroDots[heroIdx] && heroDots[heroIdx].classList.add('active'); if (heroCurrentEl) heroCurrentEl.textContent = heroIdx < 9 ? '0' + (heroIdx+1) : '' + (heroIdx+1); }
  if (heroSlides.length > 1) { heroDots.forEach(function(d) { d.addEventListener('click', function() { heroGoTo(parseInt(d.dataset.index)); clearInterval(heroTimer); heroTimer = setInterval(function() { heroGoTo(heroIdx+1); }, heroSpeed); }); }); heroTimer = setInterval(function() { heroGoTo(heroIdx+1); }, heroSpeed); }
  (function(){ var hw=document.getElementById('hero-slideshow'); if(!hw||heroSlides.length<2)return; var x0=null,y0=null; hw.addEventListener('touchstart',function(e){var t=e.changedTouches[0];x0=t.clientX;y0=t.clientY;},{passive:true}); hw.addEventListener('touchend',function(e){ if(x0===null)return; var t=e.changedTouches[0],dx=t.clientX-x0,dy=t.clientY-y0; if(Math.abs(dx)>45&&Math.abs(dx)>Math.abs(dy)){ heroGoTo(heroIdx+(dx<0?1:-1)); clearInterval(heroTimer); heroTimer=setInterval(function(){heroGoTo(heroIdx+1);},heroSpeed); } x0=y0=null; },{passive:true}); var mx=null; hw.style.cursor='grab'; hw.addEventListener('mousedown',function(e){ mx=e.clientX; hw.style.cursor='grabbing'; }); window.addEventListener('mouseup',function(e){ if(mx===null)return; var dx=e.clientX-mx; hw.style.cursor='grab'; if(Math.abs(dx)>50){ heroGoTo(heroIdx+(dx<0?1:-1)); clearInterval(heroTimer); heroTimer=setInterval(function(){heroGoTo(heroIdx+1);},heroSpeed);} mx=null; }); })();

  var searchBar = document.getElementById('search-bar'); var searchInput = document.getElementById('search-input'); document.getElementById('search-toggle') && document.getElementById('search-toggle').addEventListener('click', function() { searchBar.classList.toggle('open'); searchBar.setAttribute('aria-hidden', searchBar.classList.contains('open') ? 'false' : 'true'); if (searchBar.classList.contains('open') && searchInput) searchInput.focus(); }); document.getElementById('search-close') && document.getElementById('search-close').addEventListener('click', function() { searchBar.classList.remove('open'); searchBar.setAttribute('aria-hidden', 'true'); });
  var mobileMenu = document.getElementById('mobile-nav'); var mobileToggle = document.getElementById('mobile-menu-toggle'); if (mobileToggle && mobileMenu) mobileToggle.addEventListener('click', function() { var open = mobileMenu.classList.toggle('open'); mobileToggle.classList.toggle('active', open); mobileToggle.setAttribute('aria-expanded', open); mobileMenu.setAttribute('aria-hidden', !open); }); document.querySelectorAll('.mobile-nav-toggle').forEach(function(btn) { btn.addEventListener('click', function() { var expanded = btn.getAttribute('aria-expanded') === 'true'; btn.setAttribute('aria-expanded', !expanded); btn.nextElementSibling.classList.toggle('open'); btn.querySelector('span').textContent = expanded ? '+' : '−'; }); });
  if ('IntersectionObserver' in window) { var revealObs = new IntersectionObserver(function(entries) { entries.forEach(function(e) { if (e.isIntersecting) { e.target.classList.add('visible'); revealObs.unobserve(e.target); } }); }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }); document.querySelectorAll('.reveal').forEach(function(el) { revealObs.observe(el); }); }
  var sortSelect = document.getElementById('sort-select'); if (sortSelect) sortSelect.addEventListener('change', function() { var url = new URL(window.location.href); url.searchParams.set('sort_by', sortSelect.value); window.location.href = url.toString(); });
  var filterToggle = document.getElementById('filter-toggle'); var sidebar = document.getElementById('collection-sidebar'); var sidebarClose = document.getElementById('sidebar-close'); if (filterToggle && sidebar) { filterToggle.addEventListener('click', function() { sidebar.classList.add('open'); }); sidebarClose && sidebarClose.addEventListener('click', function() { sidebar.classList.remove('open'); }); }
  document.querySelectorAll('.filter-group-toggle').forEach(function(btn) { btn.addEventListener('click', function() { var expanded = btn.getAttribute('aria-expanded') !== 'false'; btn.setAttribute('aria-expanded', !expanded); btn.nextElementSibling.classList.toggle('collapsed'); }); });
  bindAddToCart(); setTimeout(function() { var hero = document.getElementById('hero-slideshow'); if (hero) hero.classList.add('loaded'); }, 100);
})();

/* PSI v57b — fondo bianco reale solo nelle anteprime con sfondo grigio.
   Elaborazione leggera e progressiva: una miniatura per volta, senza modificare
   le immagini Shopify e senza intervenire sulle pagine prodotto. */
(function () {
  var pending = [];
  var running = false;

  function neutral(pixelData, offset) {
    var alpha = pixelData[offset + 3];
    if (alpha < 20) return true;
    var red = pixelData[offset];
    var green = pixelData[offset + 1];
    var blue = pixelData[offset + 2];
    return Math.max(red, green, blue) >= 140 && Math.max(red, green, blue) - Math.min(red, green, blue) <= 44;
  }

  function next() {
    if (running || !pending.length) return;
    running = true;
    var element = pending.shift();
    var source = element.currentSrc || element.src;
    if (!source || source.indexOf('blob:') === 0 || source.indexOf('data:') === 0) {
      running = false;
      next();
      return;
    }

    var original = new Image();
    original.crossOrigin = 'anonymous';
    original.decoding = 'async';
    original.onload = function () {
      var limit = 760;
      var ratio = Math.min(1, limit / Math.max(original.naturalWidth, original.naturalHeight));
      var width = Math.max(1, Math.round(original.naturalWidth * ratio));
      var height = Math.max(1, Math.round(original.naturalHeight * ratio));
      var canvas = document.createElement('canvas');
      canvas.width = width;
      canvas.height = height;
      var context = canvas.getContext('2d', { willReadFrequently: true });
      if (!context) return finish();
      context.drawImage(original, 0, 0, width, height);

      var imageData;
      try {
        imageData = context.getImageData(0, 0, width, height);
      } catch (error) {
        return finish();
      }
      var data = imageData.data;
      var total = width * height;

      /* Le immagini già bianche, come il polsino, restano completamente intatte. */
      var corners = [0, width - 1, (height - 1) * width, total - 1];
      var needsCleaning = corners.every(function (index) { return neutral(data, index * 4); }) &&
        corners.some(function (index) {
          var offset = index * 4;
          return Math.min(data[offset], data[offset + 1], data[offset + 2]) < 245;
        });
      if (!needsCleaning) return finish();

      var visited = new Uint8Array(total);
      var queue = new Int32Array(total);
      var head = 0;
      var tail = 0;
      function add(index) {
        if (index < 0 || index >= total || visited[index] || !neutral(data, index * 4)) return;
        visited[index] = 1;
        queue[tail++] = index;
      }
      var x;
      var y;
      for (x = 0; x < width; x++) {
        add(x);
        add((height - 1) * width + x);
      }
      for (y = 1; y < height - 1; y++) {
        add(y * width);
        add(y * width + width - 1);
      }
      while (head < tail) {
        var index = queue[head++];
        var offset = index * 4;
        data[offset] = 255;
        data[offset + 1] = 255;
        data[offset + 2] = 255;
        data[offset + 3] = 255;
        x = index % width;
        y = (index - x) / width;
        if (x > 0) add(index - 1);
        if (x + 1 < width) add(index + 1);
        if (y > 0) add(index - width);
        if (y + 1 < height) add(index + width);
      }
      context.putImageData(imageData, 0, 0);
      canvas.toBlob(function (blob) {
        if (blob) element.src = URL.createObjectURL(blob);
        finish();
      }, 'image/webp', 0.94);
    };
    original.onerror = finish;
    original.src = source;

    function finish() {
      element.dataset.psiWhiteChecked = '1';
      running = false;
      next();
    }
  }

  function schedule(element) {
    if (!element || element.dataset.psiWhiteChecked === '1' || element.dataset.psiWhiteQueued === '1') return;
    element.dataset.psiWhiteQueued = '1';
    pending.push(element);
    next();
  }

  var images = document.querySelectorAll('.product-card-img-main');
  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        schedule(entry.target);
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '220px 0px' });
    images.forEach(function (image) { observer.observe(image); });
  } else {
    images.forEach(schedule);
  }
})();

/* PSI v56 — allinea ciascun menu desktop sotto la voce che lo apre.
   Se lo spazio a destra non basta, lo sposta solo quanto serve per mantenerlo
   interamente nello schermo. */
(function () {
  function placeDesktopMenu(item) {
    if (!window.matchMedia('(min-width: 901px)').matches) return;
    var panel = item.querySelector(':scope > .mega-menu, :scope > .dropdown-menu');
    if (!panel) return;
    item.style.setProperty('--psi-menu-left', '0px');
    var itemRect = item.getBoundingClientRect();
    var panelWidth = panel.getBoundingClientRect().width;
    var viewportPadding = 16;
    var desiredX = itemRect.left;
    var maximumX = Math.max(viewportPadding, window.innerWidth - panelWidth - viewportPadding);
    var panelX = Math.max(viewportPadding, Math.min(desiredX, maximumX));
    item.style.setProperty('--psi-menu-left', (panelX - itemRect.left) + 'px');
  }

  function placeAllDesktopMenus() {
    document.querySelectorAll('.header-nav .nav-item.has-mega, .header-nav .nav-item.has-dropdown').forEach(placeDesktopMenu);
  }

  document.querySelectorAll('.header-nav .nav-item.has-mega, .header-nav .nav-item.has-dropdown').forEach(function (item) {
    item.addEventListener('pointerenter', function () { placeDesktopMenu(item); });
    item.addEventListener('focusin', function () { placeDesktopMenu(item); });
  });
  window.addEventListener('resize', placeAllDesktopMenus, { passive: true });
  placeAllDesktopMenus();
})();

/* PSI fix: Shopify collection filters submit correctly */
(function() {
  var form = document.getElementById('collection-filter-form');
  if (!form) return;
  form.addEventListener('change', function(e) {
    if (e.target && (e.target.matches('input[type="checkbox"]') || e.target.matches('input[type="number"]'))) {
      if (e.target.matches('input[type="checkbox"]')) form.requestSubmit ? form.requestSubmit() : form.submit();
    }
  });
  form.addEventListener('submit', function() {
    form.querySelectorAll('input').forEach(function(input) {
      if ((input.type === 'checkbox' && !input.checked) || input.value === '') input.disabled = true;
    });
  });
})();


/* PSI Premium: filters auto-submit and reliable account/search helpers */
(function() {
  var filterForm = document.getElementById('collection-filter-form');
  if (filterForm) {
    filterForm.querySelectorAll('input[type="checkbox"]').forEach(function(input) {
      input.addEventListener('change', function() {
        filterForm.submit();
      });
    });
    var priceTimer;
    filterForm.querySelectorAll('.filter-price input').forEach(function(input) {
      input.addEventListener('change', function() {
        clearTimeout(priceTimer);
        priceTimer = setTimeout(function() { filterForm.submit(); }, 250);
      });
    });
  }

  document.querySelectorAll('a[href="#"]').forEach(function(a) {
    a.setAttribute('href', '/collections/all');
  });
})();


/* PSI Premium v3 filter autosubmit */
(function() {
  var form = document.getElementById('collection-filter-form');
  if (!form) return;
  form.querySelectorAll('input[type="checkbox"]').forEach(function(input) {
    input.addEventListener('change', function() { form.submit(); });
  });
})();


/* PSI mobile only UX helpers */
(function() {
  if (!window.matchMedia || !window.matchMedia('(max-width: 768px)').matches) return;

  document.querySelectorAll('.mobile-nav a').forEach(function(link) {
    link.addEventListener('click', function() {
      var nav = document.getElementById('mobile-nav');
      var toggle = document.getElementById('mobile-menu-toggle');
      if (nav) {
        nav.classList.remove('open');
        nav.setAttribute('aria-hidden', 'true');
      }
      if (toggle) {
        toggle.classList.remove('active');
        toggle.setAttribute('aria-expanded', 'false');
      }
    });
  });

  var sidebar = document.getElementById('collection-sidebar');
  var apply = document.getElementById('apply-filters');
  if (sidebar && apply) {
    apply.addEventListener('click', function() {
      sidebar.classList.remove('open');
    });
  }
})();


/* PSI fix mobile menu overlay */
(function() {
  var toggle = document.getElementById('mobile-menu-toggle');
  var nav = document.getElementById('mobile-nav');
  if (!toggle || !nav) return;

  toggle.addEventListener('click', function() {
    setTimeout(function() {
      var open = nav.classList.contains('open');
      document.body.classList.toggle('mobile-menu-open', open);
      nav.setAttribute('aria-hidden', open ? 'false' : 'true');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    }, 0);
  });

  nav.querySelectorAll('a').forEach(function(link) {
    link.addEventListener('click', function() {
      nav.classList.remove('open');
      nav.setAttribute('aria-hidden', 'true');
      toggle.classList.remove('active');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('mobile-menu-open');
    });
  });
})();


/* ============================================================
   PSI CINEMA v2 — animazioni globali (reveal, transizioni, header)
   ============================================================ */
(function() {
  'use strict';
  var reduced = false; /* animazioni sempre attive per scelta del negozio */

  /* Grana pellicola nella hero */
  var heroEl = document.getElementById('hero-slideshow');
  if (heroEl && !heroEl.querySelector('.psi-hero-grain')) {
    var grain = document.createElement('div');
    grain.className = 'psi-hero-grain';
    grain.setAttribute('aria-hidden', 'true');
    heroEl.appendChild(grain);
  }

  /* Reveal automatico: sezioni della pagina + card in griglia a scalare */
  var autoTargets = [];
  document.querySelectorAll('main .shopify-section > section').forEach(function(sec) {
    if (sec.classList.contains('hero-slideshow')) return;
    if (!sec.classList.contains('reveal')) { sec.classList.add('reveal'); autoTargets.push(sec); }
  });
  document.querySelectorAll('.products-grid .product-card, .psi-cat-grid-modern .cat-card, .psi-accessories-grid .psi-accessory-card').forEach(function(el, i) {
    if (!el.classList.contains('reveal')) {
      el.classList.add('reveal', 'psi-stagger');
      el.style.setProperty('--psi-d', ((i % 8) * 0.07) + 's');
      autoTargets.push(el);
    }
  });
  if (reduced || !('IntersectionObserver' in window)) {
    autoTargets.forEach(function(el) { el.classList.add('visible'); });
    document.querySelectorAll('.reveal').forEach(function(el) { el.classList.add('visible'); });
  } else if (autoTargets.length) {
    var psiObs = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) { e.target.classList.add('visible'); psiObs.unobserve(e.target); }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -6% 0px' });
    autoTargets.forEach(function(el) { psiObs.observe(el); });
  }

  /* Sicurezza: dopo 1.2s rende visibile tutto ciò che è già in viewport */
  setTimeout(function() {
    document.querySelectorAll('.reveal:not(.visible)').forEach(function(el) {
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0) el.classList.add('visible');
    });
  }, 1200);

  /* Transizione tra le pagine: dissolvenza in uscita sui link interni */
  if (!reduced) {
    document.addEventListener('click', function(ev) {
      var a = ev.target.closest('a[href]');
      if (!a) return;
      var href = a.getAttribute('href');
      if (!href || href.charAt(0) === '#' || a.target === '_blank' ||
          ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.altKey ||
          a.origin !== location.origin ||
          href.indexOf('/cart') === 0 || href.indexOf('/checkout') === 0 ||
          a.hasAttribute('data-no-transition') || a.closest('#cart-drawer')) return;
      ev.preventDefault();
      document.body.classList.add('psi-leaving');
      setTimeout(function() { location.href = a.href; }, 240);
    });
    window.addEventListener('pageshow', function() {
      document.body.classList.remove('psi-leaving');
    });
  }

  /* Header: si nasconde scendendo, riappare risalendo */
  var siteHeader = document.getElementById('site-header');
  if (siteHeader && !reduced) {
    var lastY = window.scrollY;
    window.addEventListener('scroll', function() {
      var y = window.scrollY;
      if (document.body.classList.contains('mobile-menu-open') || document.body.classList.contains('cart-open')) { lastY = y; return; }
      if (y > 320 && y > lastY + 10) siteHeader.classList.add('psi-header-hidden');
      else if (y < lastY - 10 || y < 140) siteHeader.classList.remove('psi-header-hidden');
      lastY = y;
    }, { passive: true });
  }
})();

/* ============================================================
   PSI V8 — altezza header, menu mobile drill-down
   ============================================================ */
(function() {
  'use strict';

  /* 2. --psi-hh segue l'altezza reale dell'header */
  var header = document.getElementById('site-header');
  function setHH() {
    if (!header) return;
    document.documentElement.style.setProperty('--psi-hh', header.offsetHeight + 'px');
  }
  setHH();
  window.addEventListener('resize', setHH);
  window.addEventListener('load', setHH);
  setTimeout(setHH, 300);

  /* 3. Menu mobile: pannello da destra con sottocategorie e freccia indietro */
  var burger = document.getElementById('psi-burger');
  var navList = document.querySelector('#site-header .nav-list');
  if (!burger || !navList) return;

  var svgBack = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 18l-6-6 6-6"/></svg>';
  var svgClose = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><path d="M18 6 6 18M6 6l12 12"/></svg>';
  var svgChev = '<svg class="psi-mnav-chev" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 6l6 6-6 6"/></svg>';
  var svgBag = '<svg class="psi-mnav-service-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 8h12l1 13H5L6 8Z"/><path d="M9 8V6a3 3 0 0 1 6 0v2"/></svg>';
  var svgUser = '<svg class="psi-mnav-service-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="8" r="4"/><path d="M4.5 21c.7-4.1 3.2-6 7.5-6s6.8 1.9 7.5 6"/></svg>';
  var svgReturn = '<svg class="psi-mnav-service-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 7H4v-5"/><path d="M4 7a9 9 0 1 1-1 9"/><path d="M9 11h6v6H9z"/></svg>';
  /* PSI mobile Nike v1: ordine, servizi e titolo */
  var svgInfo = '<svg class="psi-mnav-service-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 11v6"/><path d="M12 7h.01"/></svg>';

  /* Il blocco membership si mostra solo ai visitatori non autenticati.
     Lo stato arriva da Liquid sul <body>, quindi riflette il login reale Shopify. */
  var customerIsLoggedIn = document.body.getAttribute('data-customer-authenticated') === 'true';
  var storefrontLoginUrl = document.body.getAttribute('data-storefront-login-url') || '/customer_authentication/login';
  var accountProfileUrl = document.body.getAttribute('data-account-profile-url') || '/account';
  var memberHtml = customerIsLoggedIn ? '' :
    '<section class="psi-mnav-member" aria-label="Diventa membro Planet Sport">' +
      '<p>Diventa membro Planet Sport per accedere a offerte riservate, novità e vantaggi pensati per chi ama lo sport.</p>' +
      '<div class="psi-mnav-member-actions"><a class="psi-mnav-join" href="' + storefrontLoginUrl + '">Unisciti a noi</a><a class="psi-mnav-login" href="' + storefrontLoginUrl + '">Accedi</a></div>' +
    '</section>';

  var mnav = document.createElement('div');
  mnav.id = 'psi-mnav';
  mnav.setAttribute('aria-hidden', 'true');
  mnav.innerHTML =
    '<div class="psi-mnav-backdrop"></div>' +
    '<aside class="psi-mnav-panel" role="dialog" aria-modal="true" aria-label="Menu">' +
      '<div class="psi-mnav-top">' +
        '<button type="button" class="psi-mnav-back" aria-label="Torna al menu principale">' + svgBack + '</button>' +
        '<span class="psi-mnav-toptitle"></span>' +
        '<button type="button" class="psi-mnav-close" aria-label="Chiudi il menu">' + svgClose + '</button>' +
      '</div>' +
      '<div class="psi-mnav-viewport">' +
        '<div class="psi-mnav-screen psi-mnav-rootscr"><ul class="psi-mnav-rootlist"></ul>' +
          memberHtml +
          '<nav class="psi-mnav-foot" aria-label="Servizi">' +
            '<a class="psi-mnav-service" href="/cart">' + svgBag + '<span>Carrello</span></a>' +
            '<a class="psi-mnav-service" href="' + accountProfileUrl + '">' + svgUser + '<span>Account</span></a>' +
            '<a class="psi-mnav-service" href="/search?type=product,page&q=resi">' + svgReturn + '<span>Resi e recesso</span></a>' +
            '<a class="psi-mnav-service" href="/pages/chi-siamo">' + svgInfo + '<span>Chi siamo</span></a>' +
            '<div class="psi-mnav-foot-minor"><a href="/search?type=product,page&q=contatti">Contatti</a><a href="/search?type=product,page&q=spedizioni">Spedizioni</a></div>' +
          '</nav>' +
        '</div>' +
      '</div>' +
    '</aside>';
  document.body.appendChild(mnav);

  var viewport = mnav.querySelector('.psi-mnav-viewport');
  var rootList = mnav.querySelector('.psi-mnav-rootlist');
  var topTitle = mnav.querySelector('.psi-mnav-toptitle');
  var backBtn  = mnav.querySelector('.psi-mnav-back');
  var closeBtn = mnav.querySelector('.psi-mnav-close');
  var idx = 0;
  var mobileGfItem = null;

  /* Costruisce le voci clonando i menu del desktop (unica fonte) */
  Array.prototype.forEach.call(navList.children, function(item) {
    if (!item.classList || !item.classList.contains('nav-item')) return;
    if (item.classList.contains('nav-item-account')) return;
    var link = item.querySelector('.nav-link');
    if (!link) return;
    var label = (link.textContent || '').replace('%', '').trim();
    var labelKey = label.toLowerCase();
    if (item.classList.contains('nav-item-account-theme') || labelKey === 'account' || labelKey === 'chi siamo' || labelKey.indexOf('resi e recesso') !== -1) return;
    var isSale = !!link.querySelector('.sale-badge');
    var panel = item.querySelector('.mega-menu, .dropdown-menu');
    var li = document.createElement('li');
    var isMobileGf = item.classList.contains('nav-item-grandi-forniture');
    if (isMobileGf) li.classList.add('psi-mnav-gf');

    if (!panel) {
      li.innerHTML = '<a class="psi-mnav-item" href="' + link.getAttribute('href') + '"><span>' + label +
        (isSale ? ' <span class="sale-badge">%</span>' : '') + '</span></a>';
    } else {
      var id = 's' + (idx++);
      li.innerHTML = '<button type="button" class="psi-mnav-item" data-sub="' + id + '" aria-expanded="false"><span>' + label + '</span>' + svgChev + '</button>';

      var sub = document.createElement('div');
      sub.className = 'psi-mnav-screen psi-mnav-subscr';
      sub.setAttribute('data-sub', id);
      sub.setAttribute('data-label', label);
      var html = '<a class="psi-mnav-viewall" href="' + link.getAttribute('href') + '"><span>Vedi tutto ' + label + '</span><span>&rarr;</span></a>';

      if (panel.classList.contains('mega-menu')) {
        var cols = panel.querySelectorAll('.mega-col');
        Array.prototype.forEach.call(cols, function(col) {
          if (col.classList.contains('mega-promo')) return;
          var h = col.querySelector('.mega-heading a');
          html += '<div class="psi-mnav-group">';
          if (h) html += '<a class="psi-mnav-ghead" href="' + h.getAttribute('href') + '">' + h.textContent + '</a>';
          html += '<ul>';
          var colList = col.querySelector('ul');
          if (colList) Array.prototype.forEach.call(colList.querySelectorAll('a'), function(a) {
            html += '<li><a href="' + a.getAttribute('href') + '">' + a.innerHTML + '</a></li>';
          });
          html += '</ul></div>';
        });
        var promo = panel.querySelector('.mega-promo-card');
        if (promo) html += '<a class="psi-mnav-promo" href="' + promo.getAttribute('href') + '">' + promo.innerHTML + '</a>';
      } else {
        html += '<ul class="psi-mnav-flat">';
        Array.prototype.forEach.call(panel.querySelectorAll('a'), function(a) {
          html += '<li><a href="' + a.getAttribute('href') + '">' + a.innerHTML + '</a></li>';
        });
        html += '</ul>';
      }
      sub.innerHTML = html;
      viewport.appendChild(sub);
    }
    if (isMobileGf) mobileGfItem = li;
    else rootList.appendChild(li);
  });
  if (mobileGfItem) rootList.appendChild(mobileGfItem);

  var activeSub = null, subTimer = null;

  function openNav() {
    goRoot(true);
    mnav.classList.add('open');
    mnav.setAttribute('aria-hidden', 'false');
    burger.setAttribute('aria-expanded', 'true');
    document.body.classList.add('psi-mnav-open');
  }
  function closeNav() {
    mnav.classList.remove('open');
    mnav.setAttribute('aria-hidden', 'true');
    burger.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('psi-mnav-open');
    setTimeout(function() { goRoot(true); }, 480);
  }
  function showSub(id) {
    var sub = viewport.querySelector('.psi-mnav-subscr[data-sub="' + id + '"]');
    if (!sub) return;
    if (subTimer) { clearTimeout(subTimer); subTimer = null; }
    if (activeSub && activeSub !== sub) activeSub.classList.remove('active');
    activeSub = sub;
    sub.classList.add('active');
    sub.scrollTop = 0;
    mnav.classList.add('sub-open');
    var subLabel = sub.getAttribute('data-label') || 'Menu';
    topTitle.textContent = subLabel;
    if (subLabel.toLowerCase() === 'brand') mnav.classList.add('psi-mnav-brand-open');
    else mnav.classList.remove('psi-mnav-brand-open');
  }
  function goRoot(instant) {
    mnav.classList.remove('sub-open');
    mnav.classList.remove('psi-mnav-brand-open');
    topTitle.textContent = '';
    if (subTimer) clearTimeout(subTimer);
    if (instant) {
      if (activeSub) { activeSub.classList.remove('active'); activeSub = null; }
    } else {
      subTimer = setTimeout(function() {
        if (activeSub) { activeSub.classList.remove('active'); activeSub = null; }
      }, 480);
    }
  }

  burger.addEventListener('click', openNav);
  closeBtn.addEventListener('click', closeNav);
  backBtn.addEventListener('click', function() { goRoot(false); });
  mnav.querySelector('.psi-mnav-backdrop').addEventListener('click', closeNav);

  mnav.addEventListener('click', function(ev) {
    var btn = ev.target.closest('[data-sub]');
    if (btn && btn.classList.contains('psi-mnav-item')) { showSub(btn.getAttribute('data-sub')); return; }
    var a = ev.target.closest('a[href]');
    if (a) closeNav(); /* la transizione pagina prosegue normalmente */
  });

  document.addEventListener('keydown', function(ev) {
    if (ev.key !== 'Escape' || !mnav.classList.contains('open')) return;
    if (mnav.classList.contains('sub-open')) goRoot(false);
    else closeNav();
  });

  var mqd = window.matchMedia('(min-width: 901px)');
  function onMq() { if (mqd.matches) closeNav(); }
  if (mqd.addEventListener) mqd.addEventListener('change', onMq);
  else if (mqd.addListener) mqd.addListener(onMq);
})();


/* PSI v17: apertura filtri anche dalla barra sticky */
(function(){
  function openFilters(){
    var sidebar=document.getElementById('collection-sidebar');
    if(sidebar) sidebar.classList.add('open');
  }
  document.querySelectorAll('[data-filter-open]').forEach(function(btn){
    btn.addEventListener('click', openFilters);
  });
})();

/* PSI v18: unico tasto filtri reale, apre drawer con filtri Shopify */
(function(){
  var sidebar = document.getElementById('collection-sidebar');
  if (!sidebar) return;
  function openFilters(){ sidebar.classList.add('open'); }
  function closeFilters(){ sidebar.classList.remove('open'); }
  document.querySelectorAll('[data-filter-open]').forEach(function(btn){
    btn.addEventListener('click', function(e){ e.preventDefault(); openFilters(); });
  });
  var close = document.getElementById('sidebar-close');
  if (close) close.addEventListener('click', closeFilters);
  document.addEventListener('keydown', function(e){ if(e.key === 'Escape') closeFilters(); });
})();

/* PSI v19: chiusura pulita dropdown filtri sticky */
(function(){
  document.addEventListener('toggle', function(e){
    var d = e.target;
    if (!d.matches || !d.matches('.psi-filter-pop') || !d.open) return;
    document.querySelectorAll('.psi-filter-pop[open]').forEach(function(other){ if (other !== d) other.removeAttribute('open'); });
  }, true);
  document.addEventListener('click', function(e){
    if (e.target.closest && e.target.closest('.psi-filter-pop')) return;
    document.querySelectorAll('.psi-filter-pop[open]').forEach(function(d){ d.removeAttribute('open'); });
  });
  document.addEventListener('keydown', function(e){
    if (e.key !== 'Escape') return;
    document.querySelectorAll('.psi-filter-pop[open]').forEach(function(d){ d.removeAttribute('open'); });
  });
})();


/* PSI v20: close X for filter dropdowns */
(function(){
  document.addEventListener('click', function(e){
    var btn = e.target.closest && e.target.closest('.psi-filter-close');
    if (!btn) return;
    var pop = btn.closest('.psi-filter-pop');
    if (pop) pop.removeAttribute('open');
  });
})();

/* PSI v22: posizione dropdown filtri sopra i prodotti, con X, desktop/mobile */
(function(){
  function closeAll(except){
    document.querySelectorAll('.psi-filter-pop[open]').forEach(function(d){ if(d !== except) d.removeAttribute('open'); });
  }
  function placeDropdown(details){
    if(!details || !details.open) return;
    var summary = details.querySelector('summary');
    var dropdown = details.querySelector('.psi-filter-dropdown');
    var bar = details.closest('.psi-filter-stickybar, .psi-filter-stickybar-v19');
    if(!summary || !dropdown) return;
    var r = summary.getBoundingClientRect();
    var vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
    var isMobile = vw <= 900;
    var top = Math.round((bar ? bar.getBoundingClientRect().bottom : r.bottom) + 8);
    if(isMobile){
      details.style.setProperty('--psi-filter-top', top + 'px');
      details.style.setProperty('--psi-filter-left', '10px');
      details.style.setProperty('--psi-filter-width', (vw - 20) + 'px');
      return;
    }
    var width = details.classList.contains('psi-filter-pop-all') ? 460 : 360;
    width = Math.min(width, vw - 24);
    var left = Math.round(r.left);
    if(left + width > vw - 12) left = vw - width - 12;
    if(left < 12) left = 12;
    details.style.setProperty('--psi-filter-top', top + 'px');
    details.style.setProperty('--psi-filter-left', left + 'px');
    details.style.setProperty('--psi-filter-width', width + 'px');
  }
  document.addEventListener('toggle', function(e){
    var d = e.target;
    if(!d.matches || !d.matches('.psi-filter-pop')) return;
    if(d.open){ closeAll(d); placeDropdown(d); }
  }, true);
  document.addEventListener('click', function(e){
    var close = e.target.closest && e.target.closest('.psi-filter-close');
    if(close){
      var pop = close.closest('.psi-filter-pop');
      if(pop) pop.removeAttribute('open');
      e.preventDefault();
      return;
    }
    if(e.target.closest && e.target.closest('.psi-filter-pop')) return;
    closeAll(null);
  });
  ['resize','scroll'].forEach(function(ev){
    window.addEventListener(ev, function(){
      document.querySelectorAll('.psi-filter-pop[open]').forEach(placeDropdown);
    }, {passive:true});
  });
})();

/* PSI v25: chiude i dropdown filtri quando si apre il menu mobile */
(function(){
  function closeOpenFilterPops(){
    document.querySelectorAll('.psi-filter-pop[open]').forEach(function(d){ d.removeAttribute('open'); });
  }
  document.addEventListener('click', function(e){
    if (e.target.closest && e.target.closest('.mobile-menu-toggle')) closeOpenFilterPops();
  }, true);
})();


/* ============================================================
   PSI v29 — parallax sfondo cinematografico categorie
   ============================================================ */
(function() {
  var section = document.querySelector('[data-psi-cat-cinematic]');
  if (!section) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var bg = section.querySelector('.psi-cat-bg');
  if (!bg) return;
  var ticking = false;
  window.addEventListener('scroll', function() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function() {
      var rect = section.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      if (rect.bottom > 0 && rect.top < vh) {
        var progress = (vh - rect.top) / (vh + rect.height); // 0..1
        var shift = (progress - 0.5) * 60; // -30..30 px
        bg.style.transform = 'translateY(' + shift.toFixed(1) + 'px) scale(1.08)';
      }
      ticking = false;
    });
  }, { passive: true });
})();


/* ============================================================
   PSI v30 — filtro client-side per pagine ricerca senza filtri nativi
   Filtra le card già presenti (brand, disponibilità, taglia, colore, prezzo)
   ============================================================ */
(function() {
  var bar = document.querySelector('[data-psi-clientfilter]');
  if (!bar) return;
  var grid = document.getElementById('search-grid');
  if (!grid) return;
  var cards = Array.prototype.slice.call(grid.querySelectorAll('.product-card'));

  // Popola taglie e colori dai data-attributes delle card
  var sizeSet = {}, colorSet = {};
  cards.forEach(function(c) {
    (c.getAttribute('data-sizes') || '').split('|').forEach(function(s) { s = s.trim(); if (s) sizeSet[s] = 1; });
    (c.getAttribute('data-colors') || '').split('|').forEach(function(s) { s = s.trim(); if (s) colorSet[s] = 1; });
  });
  function fillOptions(container, values, type) {
    if (!container) return;
    var keys = Object.keys(values).sort();
    if (!keys.length) return;
    container.innerHTML = keys.map(function(v) {
      var esc = v.replace(/"/g, '&quot;');
      return '<label class="psi-chip-filter-option"><input type="checkbox" class="psi-cf" data-cf-type="' + type + '" value="' + esc + '"><span>' + v + '</span></label>';
    }).join('');
  }
  fillOptions(bar.querySelector('[data-psi-size-options]'), sizeSet, 'size');
  fillOptions(bar.querySelector('[data-psi-color-options]'), colorSet, 'color');

  function activeValues(type) {
    return Array.prototype.slice.call(bar.querySelectorAll('.psi-cf[data-cf-type="' + type + '"]:checked')).map(function(i) { return i.value; });
  }
  function normalizedColor(value) {
    return (value || '').toString().trim().toLocaleLowerCase('it');
  }
  function syncCardColorImage(card, colors) {
    var image = card.querySelector('.product-card-img-main');
    if (!image) return;
    var mediaLink = card.querySelector('.product-card-media > a');
    var titleLink = card.querySelector('.product-title');
    var optionLink = card.querySelector('.btn-select-options');
    var quickLink = card.querySelector('.btn-quick-view');

    if (!image.dataset.psiOriginalSrc) image.dataset.psiOriginalSrc = image.getAttribute('src') || image.currentSrc || image.src;
    [mediaLink, titleLink, optionLink, quickLink].forEach(function(link) {
      if (link && !link.dataset.psiOriginalHref) link.dataset.psiOriginalHref = link.href;
    });

    var selected = colors.map(normalizedColor);
    var match = Array.prototype.slice.call(card.querySelectorAll('[data-card-color][data-card-image]')).find(function(item) {
      return selected.indexOf(normalizedColor(item.getAttribute('data-card-color'))) !== -1;
    });

    if (!match) {
      if (image.dataset.psiOriginalSrc) image.src = image.dataset.psiOriginalSrc;
      [mediaLink, titleLink, optionLink, quickLink].forEach(function(link) {
        if (link && link.dataset.psiOriginalHref) link.href = link.dataset.psiOriginalHref;
      });
      return;
    }

    var mimg = match.getAttribute('data-card-image');
    if (mimg) image.src = mimg;
    var variantId = match.getAttribute('data-card-variant');
    [mediaLink, titleLink, optionLink, quickLink].forEach(function(link) {
      if (!link || !variantId) return;
      var url = new URL(link.dataset.psiOriginalHref || link.href, window.location.href);
      url.searchParams.set('variant', variantId);
      link.href = url.pathname + url.search;
    });
  }
  function applyFilters() {
    var brands = activeValues('brand');
    var avails = activeValues('availability');
    var sizes = activeValues('size');
    var colors = activeValues('color');
    var minEl = bar.querySelector('[data-cf-price="min"]');
    var maxEl = bar.querySelector('[data-cf-price="max"]');
    var min = minEl && minEl.value ? parseFloat(minEl.value) : null;
    var max = maxEl && maxEl.value ? parseFloat(maxEl.value) : null;
    var anyActive = brands.length || avails.length || sizes.length || colors.length || min !== null || max !== null;
    var shown = 0;

    cards.forEach(function(c) {
      var ok = true;
      if (brands.length && brands.indexOf(c.getAttribute('data-brand')) === -1) ok = false;
      if (ok && avails.length && avails.indexOf(c.getAttribute('data-available')) === -1) ok = false;
      if (ok && sizes.length) {
        var cs = (c.getAttribute('data-sizes') || '').split('|');
        if (!sizes.some(function(s) { return cs.indexOf(s) !== -1; })) ok = false;
      }
      if (ok && colors.length) {
        var cc = (c.getAttribute('data-colors') || '').split('|');
        if (!colors.some(function(s) { return cc.indexOf(s) !== -1; })) ok = false;
      }
      syncCardColorImage(c, ok ? colors : []);
      if (ok && (min !== null || max !== null)) {
        var p = parseFloat(c.getAttribute('data-price') || '0');
        if (min !== null && p < min) ok = false;
        if (max !== null && p > max) ok = false;
      }
      c.style.display = ok ? '' : 'none';
      if (ok) shown++;
    });

    // aggiorna contatore e stato chip
    var counter = document.querySelector('.psi-search-toolbar .collection-count');
    if (counter) counter.textContent = shown + (shown === 1 ? ' prodotto trovato' : ' prodotti trovati');
    bar.querySelectorAll('[data-psi-chip]').forEach(function(chip) {
      var type = chip.getAttribute('data-psi-chip');
      var n = type === 'price' ? ((min !== null || max !== null) ? 1 : 0) : activeValues(type).length;
      chip.classList.toggle('psi-chip-has-active', n > 0);
    });
    var clr = bar.querySelector('.psi-cf-clear');
    if (clr) clr.style.display = anyActive ? '' : 'none';
  }

  bar.addEventListener('change', function(e) {
    if (e.target.classList.contains('psi-cf')) applyFilters();
  });
  bar.addEventListener('input', function(e) {
    if (e.target.classList.contains('psi-cf-price')) applyFilters();
  });
  var clr = bar.querySelector('.psi-cf-clear');
  if (clr) clr.addEventListener('click', function(e) {
    e.preventDefault();
    bar.querySelectorAll('.psi-cf:checked').forEach(function(i) { i.checked = false; });
    bar.querySelectorAll('.psi-cf-price').forEach(function(i) { i.value = ''; });
    applyFilters();
  });
})();

/* Chiusura dropdown filtri al click sulla × e fuori */
(function() {
  document.addEventListener('click', function(e) {
    var closeBtn = e.target.closest('.psi-filter-close');
    if (closeBtn) {
      var det = closeBtn.closest('details');
      if (det) det.removeAttribute('open');
      return;
    }
    // clic fuori da un filtro aperto -> chiudi
    document.querySelectorAll('.psi-filter-pop[open]').forEach(function(det) {
      if (!det.contains(e.target)) det.removeAttribute('open');
    });
  });
})();

/* ===== PSI v41: Guida taglie, ricerca predittiva, visti di recente ===== */
(function() {
  'use strict';

  /* --- Guida alle taglie --- */
  var sgModal = document.getElementById('psi-sg-modal');
  var sgOverlay = document.getElementById('psi-sg-overlay');
  if (sgModal) {
    var sgPreviousFocus = null;
    function sgOpen() {
      sgPreviousFocus = document.activeElement;
      sgModal.setAttribute('aria-hidden','false');
      sgModal.classList.add('open');
      sgOverlay.classList.add('visible');
      document.body.classList.add('psi-sg-open');
      setTimeout(function() { var first = document.getElementById('psi-sg-close'); if (first) first.focus(); }, 0);
    }
    function sgClose() {
      sgModal.setAttribute('aria-hidden','true');
      sgModal.classList.remove('open');
      sgOverlay.classList.remove('visible');
      document.body.classList.remove('psi-sg-open');
      if (sgPreviousFocus && typeof sgPreviousFocus.focus === 'function') sgPreviousFocus.focus();
    }
    document.querySelectorAll('.size-guide-link').forEach(function(link) {
      link.addEventListener('click', function(e) { e.preventDefault(); sgOpen(); });
    });
    var sgCloseBtn = document.getElementById('psi-sg-close');
    if (sgCloseBtn) sgCloseBtn.addEventListener('click', sgClose);
    if (sgOverlay) sgOverlay.addEventListener('click', sgClose);
    document.addEventListener('keydown', function(e) {
      if (!sgModal.classList.contains('open')) return;
      if (e.key === 'Escape') { sgClose(); return; }
      if (e.key !== 'Tab') return;
      var focusable = Array.prototype.slice.call(sgModal.querySelectorAll('button:not([disabled]), input:not([disabled]), select:not([disabled]), [href], [tabindex]:not([tabindex="-1"])')).filter(function(el) { return !el.hidden && el.offsetParent !== null; });
      if (!focusable.length) return;
      var first = focusable[0], last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
    sgModal.querySelectorAll('.psi-sg-tab').forEach(function(tab) {
      tab.addEventListener('click', function() {
        sgModal.querySelectorAll('.psi-sg-tab').forEach(function(t) { t.classList.remove('active'); t.setAttribute('aria-selected','false'); });
        sgModal.querySelectorAll('.psi-sg-panel').forEach(function(pn) { pn.classList.remove('active'); });
        tab.classList.add('active'); tab.setAttribute('aria-selected','true');
        var panel = sgModal.querySelector('.psi-sg-panel[data-sg-panel="' + tab.dataset.sgTab + '"]');
        if (panel) panel.classList.add('active');
      });
    });
  }

  /* --- Ricerca predittiva --- */
  function psiEsc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  var searchInput = document.getElementById('search-input');
  var predictive = document.getElementById('psi-predictive');
  if (searchInput && predictive) {
    var psTimer = null, psController = null, psActiveIndex = -1, psRequestSeq = 0, psRenderedTerm = '', psProductOrder = [], psPreviousProducts = [], psCache = Object.create(null);
    var psRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    function psItems() { return Array.prototype.slice.call(predictive.querySelectorAll('[role="option"]')); }
    function psSetActive(index) {
      var items = psItems();
      if (!items.length) return;
      psActiveIndex = (index + items.length) % items.length;
      items.forEach(function(item, i) {
        var active = i === psActiveIndex;
        item.classList.toggle('is-keyboard-active', active);
        item.setAttribute('aria-selected', String(active));
      });
      searchInput.setAttribute('aria-activedescendant', items[psActiveIndex].id);
      items[psActiveIndex].scrollIntoView({ block: 'nearest' });
    }
    function psCancelPending() {
      clearTimeout(psTimer);
      psTimer = null;
      psRequestSeq++;
      if (psController) {
        try { psController.abort(); } catch (e) {}
        psController = null;
      }
    }
    function psHide() {
      psCancelPending();
      predictive.hidden = true;
      predictive.innerHTML = '';
      predictive.removeAttribute('aria-busy');
      psActiveIndex = -1;
      searchInput.setAttribute('aria-expanded', 'false');
      searchInput.removeAttribute('aria-activedescendant');
    }
    function psProductKey(product) {
      return product && (product.url || product.title || '');
    }
    function psProductMatches(product, normalizedTerm) {
      var title = String(product && product.title || '').toLocaleLowerCase('it-IT');
      var words = normalizedTerm.split(/\s+/).filter(Boolean);
      return words.length > 0 && words.every(function(word) {
        return title.indexOf(word) !== -1;
      });
    }
    function psStableProducts(products, term) {
      var normalizedTerm = String(term || '').toLocaleLowerCase('it-IT');
      var keepsPrefix = psRenderedTerm && normalizedTerm.indexOf(psRenderedTerm) === 0;
      var next = products.slice();

      /* Una seconda risposta per lo stesso testo non puo' piu' ridisegnare
         le schede: il primo elenco valido rimane quello definitivo. */
      if (normalizedTerm === psRenderedTerm && psPreviousProducts.length) {
        return psPreviousProducts.slice();
      }

      /* Se si completa la stessa parola (za -> zai -> zain -> zaino), teniamo
         davanti le schede gia' visibili che corrispondono ancora al testo.
         Anche se Shopify le sposta oltre i primi sei risultati, non saltano
         davanti/indietro sotto gli occhi del cliente. I nuovi prodotti si
         aggiungono soltanto dopo, senza duplicati. */
      if (keepsPrefix && psPreviousProducts.length) {
        var seen = {};
        var stable = [];
        var limit = Math.max(products.length, psPreviousProducts.length);

        psPreviousProducts.forEach(function(product) {
          var key = psProductKey(product);
          if (!key || seen[key] || !psProductMatches(product, normalizedTerm)) return;
          seen[key] = true;
          stable.push(product);
        });

        products.forEach(function(product) {
          var key = psProductKey(product);
          if (!key || seen[key]) return;
          seen[key] = true;
          stable.push(product);
        });

        next = stable.slice(0, limit);
      }

      psRenderedTerm = normalizedTerm;
      psPreviousProducts = next.slice();
      psProductOrder = next.map(psProductKey);
      return next;
    }
    function psRender(results, term) {
      var products = psStableProducts(results.products || [], term);
      var queries = results.queries || [];
      var collections = results.collections || [];
      var pages = results.pages || [];
      if (!products.length && !queries.length && !collections.length && !pages.length) { psHide(); return; }
      var optionIndex = 0;
      var html = '';
      function simpleGroup(items, label, kind) {
        if (!items.length) return '';
        var group = '<div class="psi-predictive-group"><p class="psi-predictive-heading">' + label + '</p><ul class="psi-predictive-links" role="presentation">';
        items.forEach(function(item) {
          var title = item.text || item.title || '';
          var href = item.url || (psRoot + 'search?type=product&q=' + encodeURIComponent(title));
          group += '<li role="presentation"><a id="psi-predictive-option-' + optionIndex++ + '" role="option" aria-selected="false" tabindex="-1" href="' + psiEsc(href) + '" class="psi-predictive-link" data-result-type="' + kind + '">' + psiEsc(title) + '</a></li>';
        });
        return group + '</ul></div>';
      }
      html += simpleGroup(queries.slice(0, 3), 'Ricerche suggerite', 'query');
      if (products.length) html += '<div class="psi-predictive-group"><p class="psi-predictive-heading">Prodotti</p><ul class="psi-predictive-list" role="presentation">';
      products.forEach(function(pr) {
        var img = pr.image ? pr.image.replace(/(\.[a-z]{3,4})(\?|$)/, '_120x150_crop_center$1$2') : '';
        html += '<li role="presentation"><a id="psi-predictive-option-' + optionIndex++ + '" role="option" aria-selected="false" tabindex="-1" href="' + psiEsc(pr.url) + '" class="psi-predictive-item" data-result-type="product">' +
          (img ? '<img src="' + psiEsc(img) + '" alt="" loading="lazy" width="48" height="60">' : '<span class="psi-predictive-noimg"></span>') +
          '<span class="psi-predictive-info"><span class="psi-predictive-title">' + psiEsc(pr.title) + '</span>' +
          (pr.price ? '<span class="psi-predictive-price">' + Number(pr.price).toLocaleString('it-IT', { style: 'currency', currency: 'EUR' }) + '</span>' : '') +
          '</span></a></li>';
      });
      if (products.length) html += '</ul></div>';
      html += simpleGroup(collections.slice(0, 3), 'Collezioni', 'collection');
      html += simpleGroup(pages.slice(0, 2), 'Informazioni', 'page');
      html += '<a id="psi-predictive-option-all" role="option" aria-selected="false" tabindex="-1" class="psi-predictive-all" data-result-type="all" href="' + psRoot + 'search?type=product&q=' + encodeURIComponent(term) + '">Vedi tutti i risultati per “' + psiEsc(term) + '”</a>';
      predictive.innerHTML = html;
      predictive.hidden = false;
      psActiveIndex = -1;
      searchInput.setAttribute('aria-expanded', 'true');
      searchInput.removeAttribute('aria-activedescendant');
      if (typeof window.psiTrack === 'function') window.psiTrack('search_suggestions_view', { query_length: term.length, result_count: optionIndex });
    }
    searchInput.addEventListener('input', function() {
      var term = searchInput.value.trim();
      var requestSeq;

      clearTimeout(psTimer);
      psTimer = null;
      psRequestSeq++;
      requestSeq = psRequestSeq;

      /* Annulla SUBITO la parola precedente, non dopo il debounce. Questo
         chiude anche la finestra di gara sui Safari che ignorano AbortController:
         ogni risposta deve comunque avere numero e testo ancora correnti. */
      if (psController) {
        try { psController.abort(); } catch (e) {}
        psController = null;
      }

      if (term.length < 2) {
        psRenderedTerm = '';
        psProductOrder = [];
        psPreviousProducts = [];
        psHide();
        return;
      }

      var cacheKey = term.toLocaleLowerCase('it-IT');
      if (Object.prototype.hasOwnProperty.call(psCache, cacheKey)) {
        psRender(psCache[cacheKey], term);
        predictive.removeAttribute('aria-busy');
        return;
      }

      predictive.setAttribute('aria-busy', 'true');
      psTimer = setTimeout(function() {
        var controller;
        if (requestSeq !== psRequestSeq || searchInput.value.trim() !== term) return;

        controller = ('AbortController' in window) ? new AbortController() : null;
        psController = controller;

        fetch(psRoot + 'search/suggest.json?q=' + encodeURIComponent(term) + '&resources[type]=query,product,collection,page&resources[limit]=10&resources[limit_scope]=each&resources[options][unavailable_products]=show', controller ? { signal: controller.signal } : {})
          .then(function(r) {
            if (!r.ok) throw new Error('predictive-search');
            return r.json();
          })
          .then(function(data) {
            if (requestSeq !== psRequestSeq || searchInput.value.trim() !== term) return;
            var result = (data && data.resources && data.resources.results) || {};
            result.products = (result.products || []).map(function(pr) { return { title: pr.title, url: pr.url, image: pr.featured_image && pr.featured_image.url ? pr.featured_image.url : (pr.image || ''), price: pr.price }; });
            psCache[cacheKey] = result;
            psRender(result, term);
            predictive.removeAttribute('aria-busy');
            if (psController === controller) psController = null;
          })
          .catch(function(error) {
            if (requestSeq !== psRequestSeq || searchInput.value.trim() !== term) return;
            predictive.removeAttribute('aria-busy');
            if (!error || error.name !== 'AbortError') psHide();
          });
      }, 0);
    });
    searchInput.addEventListener('keydown', function(e) {
      if (predictive.hidden) return;
      var items = psItems();
      if (!items.length) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); psSetActive(psActiveIndex + 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); psSetActive(psActiveIndex < 0 ? items.length - 1 : psActiveIndex - 1); }
      else if (e.key === 'Home' && psActiveIndex >= 0) { e.preventDefault(); psSetActive(0); }
      else if (e.key === 'End' && psActiveIndex >= 0) { e.preventDefault(); psSetActive(items.length - 1); }
      else if (e.key === 'Enter' && psActiveIndex >= 0) { e.preventDefault(); window.location.assign(items[psActiveIndex].href); }
      else if (e.key === 'Escape') { e.preventDefault(); psHide(); }
    });
    predictive.addEventListener('mousedown', function(e) { if (e.target.closest('[role="option"]')) e.preventDefault(); });
    document.addEventListener('click', function(e) {
      if (!predictive.contains(e.target) && e.target !== searchInput) psHide();
    });
    document.addEventListener('keydown', function(e) { if (e.key === 'Escape') psHide(); });
  }

  /* --- Visti di recente — v223: schede coerenti e link canonici --- */
  var RECENT_KEY = 'psi_recent_products';
  function recentPreferencesAllowed() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    return !privacy || typeof privacy.preferencesProcessingAllowed !== 'function' || privacy.preferencesProcessingAllowed();
  }
  function recentGet() {
    if (!recentPreferencesAllowed()) return [];
    try {
      var value = JSON.parse(localStorage.getItem(RECENT_KEY)) || [];
      return Array.isArray(value) ? value : [];
    } catch (e) { return []; }
  }
  function recentSet(list) {
    if (!recentPreferencesAllowed()) return;
    try { localStorage.setItem(RECENT_KEY, JSON.stringify(list.slice(0, 8))); } catch (e) {}
  }
  function recentProductUrl(item) {
    var handle = item && item.handle ? String(item.handle).replace(/[^a-zA-Z0-9_-]/g, '') : '';
    return handle ? '/products/' + encodeURIComponent(handle) : (item.url || '/collections/all');
  }
  function recentImages(item) {
    var images = Array.isArray(item.images) ? item.images.filter(Boolean) : [];
    if (!images.length && item.image) images = [item.image];
    return images.slice(0, 4);
  }

  var currentEl = document.getElementById('psi-current-product');
  if (currentEl) {
    var current = null;
    try { current = JSON.parse(currentEl.textContent); } catch (e) {}
    if (current && current.handle) {
      current.url = recentProductUrl(current);
      current.images = recentImages(current);
      current.image = current.images[0] || current.image || '';

      var list = recentGet().filter(function(x) {
        return x && x.handle && x.handle !== current.handle;
      });

      var grid = document.getElementById('psi-recent-grid');
      var section = document.getElementById('psi-recent-section');
      if (grid && section && list.length) {
        var html = '';
        list.forEach(function(x) {
          var href = recentProductUrl(x);
          var images = recentImages(x);
          var main = images[0] || '';
          var thumbs = '';
          images.forEach(function(src, index) {
            thumbs += '<a class="psi-recent-thumb' + (index === 0 ? ' is-active' : '') + '" href="' + href + '" aria-label="Apri ' + psiEsc(x.title) + '">' +
              '<img src="' + psiEsc(src) + '" alt="" loading="lazy" width="120" height="120">' +
            '</a>';
          });

          html += '<article class="product-card psi-recent-card-v223">' +
            '<div class="product-card-media"><a href="' + href + '" aria-label="' + psiEsc(x.title) + '">' +
              (main ? '<img class="product-card-img-main" src="' + psiEsc(main) + '" alt="' + psiEsc(x.title) + '" loading="lazy" width="720" height="720">' : '<div class="psi-noimg"><span class="psi-noimg-title">' + psiEsc(x.title) + '</span><span class="psi-noimg-label">Foto in arrivo</span></div>') +
            '</a></div>' +
            (thumbs ? '<div class="psi-recent-thumbs" aria-label="Anteprime del prodotto">' + thumbs + '</div>' : '') +
            '<div class="product-card-info">' +
              (x.brand ? '<span class="product-brand">' + psiEsc(x.brand) + '</span>' : '') +
              '<a href="' + href + '" class="product-title">' + psiEsc(x.title) + '</a>' +
              (x.price ? '<div class="product-price"><span class="price-regular">' + psiEsc(x.price) + '</span></div>' : '') +
            '</div>' +
          '</article>';
        });
        grid.innerHTML = html;
        section.hidden = false;
      }

      list.unshift(current);
      recentSet(list);
    }
  }
})();

/* Transizione di navigazione: barra di caricamento in alto */
(function(){
  var bar=document.getElementById('psi-nav-progress');
  if(!bar) return;
  var running=false,t1,t2;
  var rev=document.getElementById('psi-page-reveal'); function start(){ if(running)return; running=true; if(rev){ rev.classList.remove('psi-pr-closing'); void rev.offsetWidth; rev.classList.add('psi-pr-closing'); } bar.classList.add('psi-active'); bar.style.width='0%'; requestAnimationFrame(function(){bar.style.width='72%';}); t1=setTimeout(function(){if(running)bar.style.width='88%';},450); t2=setTimeout(function(){if(running)bar.style.width='95%';},1400); }
  function reset(){ running=false; clearTimeout(t1); clearTimeout(t2); bar.classList.remove('psi-active'); bar.style.width='0%'; }
  document.addEventListener('click',function(e){ var a=e.target.closest('a'); if(!a)return; var href=a.getAttribute('href'); if(!href||href.charAt(0)==='#'||href.indexOf('javascript:')===0||href.indexOf('mailto:')===0||href.indexOf('tel:')===0)return; if(a.target&&a.target!=='_self')return; if(a.hasAttribute('download'))return; if(a.hostname&&a.hostname!==location.hostname)return; if(e.defaultPrevented||e.metaKey||e.ctrlKey||e.shiftKey||e.button!==0)return; start(); },true);
  window.addEventListener('pageshow',reset);
})();

/* Pagina prodotto: SKU dinamico nel breadcrumb + Acquista ora + pagamenti diretti */
(function(){
  var skuEl=document.getElementById('psi-sku');
  var dataEl=document.getElementById('psi-variant-sku');
  var idInput=document.getElementById('selected-variant-id');
  if(!idInput) return;
  var map={}, handle='';
  if(dataEl){ try{ var d=JSON.parse(dataEl.textContent); map=d.map||{}; handle=d.handle||''; }catch(e){} }
  function updateSku(){ if(!skuEl)return; var s=map[idInput.value]; skuEl.textContent=(s&&(''+s).length)?s:handle; }
  var opts=document.getElementById('product-options');
  if(opts){ opts.addEventListener('click', function(){ setTimeout(updateSku,40); }); }
  updateSku();
  function buyNow(){
    var q=1; var qi=document.getElementById('qty-input'); if(qi){ q=parseInt(qi.value||'1',10)||1; }
    var bn=document.getElementById('buy-now-btn'); if(bn){ bn.disabled=true; bn.textContent='Attendere…'; }
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:idInput.value,quantity:q})})
      .then(function(r){ return r.ok?r.json():Promise.reject(); })
      .then(function(){ window.location.href='/checkout'; })
      .catch(function(){ window.location.href='/cart'; });
  }
  var bnb=document.getElementById('buy-now-btn'); if(bnb) bnb.addEventListener('click', buyNow);
  Array.prototype.forEach.call(document.querySelectorAll('[data-psi-buy]'), function(b){ b.addEventListener('click', buyNow); });
})();

/* ============================================================
   PSI v316 — eventi analytics anonimi
   Espone sia dataLayer (GTM) sia eventi DOM psi:analytics.
   Non invia email, termini digitati o altri dati personali.
   ============================================================ */
(function() {
  'use strict';
  if (typeof window.psiTrack === 'function') return;

  window.dataLayer = window.dataLayer || [];
  function psiAnalyticsAllowed() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    return !privacy || typeof privacy.analyticsProcessingAllowed !== 'function' || privacy.analyticsProcessingAllowed();
  }
  window.psiTrack = function(name, properties) {
    if (!name || !psiAnalyticsAllowed()) return false;
    var safeName = String(name).replace(/[^a-z0-9_]+/gi, '_').toLowerCase();
    var payload = { event: 'psi_' + safeName };
    Object.keys(properties || {}).forEach(function(key) {
      var value = properties[key];
      if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') payload[key] = value;
    });
    window.dataLayer.push(payload);
    try { window.dispatchEvent(new CustomEvent('psi:analytics', { detail: payload })); } catch (e) {}
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish('planet_sport:' + safeName, payload);
      }
    } catch (e) {}
    return true;
  };

  document.addEventListener('submit', function(e) {
    if (e.target.matches('.psi-search-form')) {
      var input = e.target.querySelector('[name="q"]');
      window.psiTrack('search_submit', { query_length: input ? input.value.trim().length : 0 });
    } else if (e.target.id === 'psi-stock-form') {
      var productRoot = document.getElementById('psi-product-upgrades');
      window.psiTrack('restock_request_submit', { product_handle: productRoot ? productRoot.dataset.handle : '' });
    }
  });

  document.addEventListener('change', function(e) {
    var input = e.target;
    if (!input.matches('.collection-filter-form input, .psi-chip-filter-form input, .psi-sidebar-filter-form input, .psi-cf, .psi-cf-price')) return;
    window.psiTrack('catalog_filter_change', {
      filter_name: (input.name || input.dataset.cfType || 'unknown').slice(0, 80),
      filter_kind: input.type || 'unknown',
      active: input.type === 'checkbox' ? input.checked : String(input.value || '').length > 0
    });
  });

  document.addEventListener('click', function(e) {
    var option = e.target.closest('#psi-predictive [role="option"]');
    if (option) {
      var options = Array.prototype.slice.call(option.parentElement.querySelectorAll ? document.querySelectorAll('#psi-predictive [role="option"]') : []);
      window.psiTrack('search_result_select', { position: options.indexOf(option) + 1, result_type: option.dataset.resultType || 'unknown', all_results: option.id === 'psi-predictive-option-all' });
    }

    var boxChoice = e.target.closest('.psibox [data-action]');
    if (boxChoice) window.psiTrack('box_configurator_select', { step: boxChoice.dataset.action || '', selection: (boxChoice.dataset.value || '').slice(0, 80) });

    var boxCart = e.target.closest('.psibox [data-add-cart]');
    if (boxCart) window.psiTrack('box_configurator_add_to_cart', { enabled: !boxCart.disabled });

    var notify = e.target.closest('#psi-notify-toggle');
    if (notify) window.psiTrack('restock_request_open', { expanded: notify.getAttribute('aria-expanded') === 'true' });
  });
})();
